const ENABLE_DEBUG_LOGGING = true;

export const debugLog = (...contents) => {
	if (ENABLE_DEBUG_LOGGING) {
		console.log(...contents);
	}
}